import { ChangeDetectionStrategy, Component, input } from '@angular/core';

/**
 * Placeholder « rien ici » — l'encadré pointillé centré était recopié dans ~28 fichiers.
 * Le contenu (texte, liens, CTA) est projeté ; l'icône est optionnelle.
 *
 *   <wh-empty-state icon="pi-map">Aucun champ de correction — lance un relevé…</wh-empty-state>
 */
@Component({
  selector: 'wh-empty-state',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div
      class="rounded-xl border border-dashed border-gray-300 p-8 text-center text-sm text-gray-400 dark:border-slate-600 dark:text-slate-500">
      @if (icon()) {
        <i class="pi mb-2 block text-2xl" [class]="icon()"></i>
      }
      <ng-content />
    </div>
  `,
})
export class WhEmptyStateComponent {
  /** Classe d'icône PrimeIcons (ex. « pi-map ») — rien = pas d'icône. */
  readonly icon = input<string | null>(null);
}
